import SwimlaneStatus from './SwimlaneStatus';

export default SwimlaneStatus;
